const locationOrigin = window.location.origin

export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '毕业申-专注于校园招聘',
    /**
     * @description token在Cookie中存储的天数，默认1天
     */

    API_ROOT: "https://api.applyoffer.com/",
    cookieExpires: 30,
    // 用户id key
    cookie_key_user: 'user_id',
    cookie_key_company: 'company_id',
    // 服务端登录态标志
    cookie_key_server: 'uniq_user_token',
    /**
     * @description 是否使用国际化，默认为false
     *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
     *              用来在菜单中显示文字
     */
    useI18n: true,
    /**
     * @description api请求基础路径
     */
    baseUrl: {
        dev: `${locationOrigin}/interface`,
        daily: `${locationOrigin}/interface`,
        pro: `${locationOrigin}/interface`
      },
    /**
     * @description 接口前缀，为了配置本地代理服务端
     */
    apiPrefix: 'interface',
    /**
     * @description 登录，header 文案
     */
    headerText: '',

    /**
     * @description 默认打开的首页的路由name值，默认为home
     */
    homeName: 'home',
    /**
     * @description 需要加载的插件
     */
    plugin: {
        'error-store': {
            showInHeader: true, // 设为false后不会在顶部显示错误日志徽标
            developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误
        }
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js